import { Component, OnDestroy } from '@angular/core';
import { MatLegacySelectChange as MatSelectChange } from '@angular/material/legacy-select';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { ICellEditorParams } from 'ag-grid-community';
import { Subject, BehaviorSubject } from 'rxjs';
import { takeUntil, finalize } from 'rxjs/operators';

import { SnackBarConfig } from '../../../shared/configs/snackbar.config';
import { AssemblyOrderApiService } from '../../../shared/services/api/assembly-order-api.service';
import { EAssemblyOrderStatus } from '../../interfaces/assembly-order.interface';

@Component({
  selector: 'lum-assembly-order-status-cell-editor',
  templateUrl: './assembly-order-status-cell-editor.component.html',
  styleUrls: ['./assembly-order-status-cell-editor.component.scss'],
})
export class AssemblyOrderStatusCellEditorComponent
  implements ICellEditorAngularComp, OnDestroy
{
  value :string = '';
  oldValue :string = '';

  assemblyOrderStatus = EAssemblyOrderStatus;

  private readonly _loading = new BehaviorSubject<boolean>(<boolean>false);
  loading$ = this._loading.asObservable();

  private cellEditorParams :ICellEditorParams;
  private onDestroy$ = new Subject<void>();

  constructor(
    private assemblyOrderApiService :AssemblyOrderApiService,
    private snackBar :MatSnackBar,
  ) {}

  agInit(params :ICellEditorParams) :void {
    this.cellEditorParams = params;

    this.value = this.cellEditorParams.value;
    this.oldValue = this.value;
  }

  ngOnDestroy() :void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

  getValue() :string {
    return this.cellEditorParams.value;
  }

  onSelectionChange(event :MatSelectChange) :void {
    if (this.value === this.oldValue) {
      this.onCancelEditing();

      return;
    }

    this._loading.next(true);
    this.assemblyOrderApiService
      .updateStatus(this.cellEditorParams.data.id, {
        status: this.value,
      })
      .pipe(
        takeUntil(this.onDestroy$),
        finalize(() => {
          this._loading.next(false);
          this.onCancelEditing();
        }),
      )
      .subscribe({
        next: (response :any) => {
          this.cellEditorParams.value = this.value;

          if (this.value === EAssemblyOrderStatus.COMPLETED) {
            this.cellEditorParams.api.applyTransaction({
              remove: [this.cellEditorParams.node.data],
            });
          }

          this.snackBar.open('Successfully updated order status.', 'Success', {
            duration: SnackBarConfig.DEFAULT.duration,
          });
        },
        error: (error :any) => {
          this.cellEditorParams.value = this.oldValue;

          this.snackBar.open('Error updating order status.', 'Error', {
            duration: SnackBarConfig.DEFAULT.duration,
          });
        },
      });
  }

  private onCancelEditing() :void {
    this.cellEditorParams.stopEditing();
    this.cellEditorParams.api.stopEditing();
  }
}
